/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect, useRef } from "react";
import { Tabs, Button, Checkbox, Modal, Popover } from "antd";
import Relative from "./Relative";
import Absolute from "./Absolute";
import { useDispatch, useSelector } from "react-redux";
import {
  setDiffInDays,
  getPaneIndex,
  getThreeSplitDate,
  getCustomizedDate,
  getTimeInterval,
  handleScheduleDateChange,
  handleGenerateDateChange,
  useQuery,
  updateHighchartOptionData,
  getWidgetMakerFlag,
  callNotification,
  getEmptyFieldNotification,
  splitSectionWidgets,
  deepCopy,
  checkForDuplicateWidgets,
  getFilterDuplicateWidgets,
} from "../../../redux/constants";

import moment from "moment";
import {
  setDateTimeFlag,
  updateDashboardDuration,
  updateSectionDuration,
  setGlobalDateValue,
  setSectionDateValue,
  updateWidgetDuration,
  setWidgetDateValue,
  setGraphPageDateValue,
  setSplitDateValue,
  setOrmDateValue,
  setPrevieDate,
  setCommandCenterDateValue,
} from "../../../redux/actions/DateTime";
import durationIcon from "../../../assets/calendarIconLB.svg";
import durationWhiteIcon from "../../../assets/WhiteIcons/calendarWhiteIconLB.svg";
import {
  setClearGraphData,
  setPaneDuration,
  setSelectedDeepdiveWidget,
} from "../../../redux/actions/dashboard/Tab1";
import {
  setSectionDuration,
  setTemplateDetails,
  setTemplateFilter,
  setTemplateSectionFilter,
  setTemplateWidgetFilter,
  setWidgetDuration,
} from "../../../redux/actions/section/section";
import { setGraphDuration } from "../../../redux/actions/dashboard/Welcome";
import {
  setTicketOverviewInterval,
  setTicketOverviewWidget1,
  setTicketOverviewWidget2,
  setSocialMediaDropdownOptions,
} from "../../../redux/actions/ApiCall/apiCall";
import {
  setShareSelectedDeepdiveWidget,
  setSharedDuration,
} from "../../../redux/actions/share/Share";
import { setWidgetMakerDuration } from "../../../redux/actions/WidgetMaker/GraphConfig";
import { setGlobalDuration } from "../../../redux/actions/AuthParams";
import { setIsWidgetEdit } from "../../../redux/actions/Filter";
import {
  setPageChart,
  setWidgetMakerGraphData,
} from "../../../redux/actions/WidgetMaker/WidgetAPI";

import { getTimeIntervalForDate } from "../../../redux/constants";
import { setScheduleReport } from "../../../redux/actions/scheduleReport/scheduleReport";
import { setOptionHighChart } from "../../../redux/actions/HighChart";
import isEqual from "react-fast-compare";
import { setClearBrandAndDuration } from "../../../redux/actions/Template";
import { setGlobalSelectedWidgetId } from "../../../redux/actions/dashboard/dashboard";
import {
  setCategoryScreenFilters,
  setClearAllScreenWidgetGraphData,
  setDurationInScreen,
  setScreenRefreshEvent,
  setSelectedDurationTypeFlag,
} from "../../../redux/actions/commandCenter/screens/screen";
import {
  setIsNetworkWidgetSettingEdit,
  setNetworkWidgetSettingObject,
} from "../../../redux/actions/Network";

const Datetime = ({
  type,
  dashboard,
  split,
  checked,
  crisis,
  setChecked,
  onSplitDateChange,
  preview_metadata,
  ThreeSplitDate,
  scheduleReport,
}) => {
  let query = useQuery();
  const refDate = useRef(null);
  const refDatecheckbox = useRef(null);

  const { TabPane } = Tabs;
  const dispatch = useDispatch();
  const [datePicker, setDatepicker] = useState(false);
  const [positionY, setPositiony] = useState({ top: 0, left: 0, right: 0 });
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const aggregateLoader = useSelector((state) => state.apiCall.aggregateLoader);
  const graphLoader = useSelector((state) => state.apiCall.loader); //display chart loader
  const profileLoader = useSelector((state) => state.apiCall.profileLoader);

  const sharedDuration = useSelector((state) => state.Share.sharedDuration);
  const selectedSection = useSelector((state) => state.Section.filterObject);
  const templateBrandObj = useSelector(
    (state) => state?.Template?.templateBrandObj
  );
  const dateValue = useSelector((state) => state.DateTime.dateValue);
  const timeValue = useSelector((state) => state.DateTime.timeValue);
  const previewDate = useSelector((state) => state.DateTime.previewDate);
  const editPanelInfo = useSelector((state) => state.dashboard?.editPanelInfo);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );

  // store info about command center screen
  const screen = useSelector((state) => state?.Screens?.screen);

  const [localDate, setlocalDate] = useState(null);
  const [localTime, setlocalTime] = useState({
    endTime: "23:59",
    startTime: "00:00",
  });
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const [check, setcheck] = useState({ one: false, two: false, three: false });

  const workspaceFormData = useSelector(
    (state) => state?.CreateWorkspace?.workspaceFormData
  );

  const crisisChecked = useSelector((state) => state.DateTime.crisisChecked);
  const [timeFlag, settimeFlag] = useState([
    { type: "start", data: { value: false, msg: null } },
    { type: "end", data: { value: false, msg: null } },
  ]);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const Section = useSelector((state) => state.Section.addSection);
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);
  const ormDate = useSelector((state) => state.Orm.ormDate);

  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const opData = useSelector((state) => state.Highchart.Options);
  function callback(key) {}
  const [isModalVisible1, setIsModalVisible1] = useState(false);
  const [keepAsRelative, setKeepAsRelative] = useState(false);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const widgetMakerDuration = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig?.duration
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const dashboardDateFilterObj = useSelector(
    (state) => state?.DateTime?.dashboardDateFilterObj
  );
  const wm_api_flag = useSelector((state) => state.WidgetMaker.wm_api_flag);
  const relativeCount = useSelector((state) => state.DateTime.relativeCount);
  const scheduleObj = useSelector((state) => state.scheduleReport.scheduleObj);
  const previewBrands = useSelector(
    (state) => state?.Logicalgroup.previewBrands
  ); // selected brand values
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const visitedWidgetId = useSelector(
    (state) => state?.dashboard?.visited_widget_id
  );
  // const profileFilterList = useSelector(
  //   (state) => state?.apiCall?.profile_filter_list
  // );
  let index = getPaneIndex(panes, activeKey);
  const profileFilterList =
    window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
    window.location.pathname?.split("/")?.[1] === "create-dashboard"
      ? templateDetails?.profile_filters_list
      : panes?.[index]?.profile_filters_list;

  const clearBrandAndDuration = useSelector(
    (state) => state?.Template?.clearBrandAndDuration
  ); //contains information about clear filter
  const {
    selectedFrequency,
    scheduleDay,
    scheduleTime,
    selectedLastXDays,
    selectedDataDuration,
    scheduleDate,
    scheduleMonth,
    TimeOffsetText,
  } = scheduleObj;

  useEffect(() => {
    //this is to reset date time values according to types

    resetState();
  }, [type, sharedDuration, widgetMakerDuration, panes, screen?.duration]);
  // to set checkbox value for for relative duration
  useEffect(
    () => {
      if (dateValue[type] && dateValue[type]?.data?.save_as_relative) {
        setKeepAsRelative(true);
      } else {
        setKeepAsRelative(false);
      }
    },
    [panes?.[index]?.duration],
    dateValue[type]
  );
  const resetState = () => {
    let index = getPaneIndex(panes, activeKey);
    let global_duration = panes[index]?.duration;
    // to relative date value set
    // if (global_duration?.from) {
    //   let diff_in_hours = moment(global_duration?.to).diff(
    //     moment(global_duration?.from),
    //     "hours",
    //     true
    //   );
    //   if (diff_in_hours <= 24) {
    //     global_duration.relative = { value: diff_in_hours, type: "Hours" };
    //   }
    // }
    let section_duration =
      editPanelInfo?.type === "dashboard_section" && panes[index]?.sections
        ? panes[index]?.sections[editPanelInfo?.section_index]?.duration
        : null;
    // to relative date value set
    // if (section_duration?.from) {
    //   let diff_in_hours = moment(section_duration?.to).diff(
    //     moment(section_duration?.from),
    //     "hours",
    //     true
    //   );
    //   if (diff_in_hours <= 24) {
    //     section_duration.relative = { value: diff_in_hours, type: "Hours" };
    //   }
    // }
    let widget_duration =
      editPanelInfo?.type === "dashboard_widget" && panes[index]?.sections
        ? {
            from: panes[index]?.sections[editPanelInfo?.section_index]?.widgets
              ? panes[index]?.sections[editPanelInfo?.section_index]?.widgets[
                  editPanelInfo?.widget_index
                ]?.start_date
              : null,
            to: panes[index]?.sections[editPanelInfo?.section_index]?.widgets
              ? panes[index]?.sections[editPanelInfo?.section_index]?.widgets[
                  editPanelInfo?.widget_index
                ]?.end_date
              : null,
          }
        : editPanelInfo?.type === "dashboard_widget" && panes[index]?.section
        ? {
            from: panes[index]?.section[0]?.widgets
              ? panes[index]?.section[0]?.widgets[editPanelInfo?.widget_index]
                  ?.start_date
              : null,
            to: panes[index]?.section[0]?.widgets
              ? panes[index]?.section[0]?.widgets[editPanelInfo?.widget_index]
                  ?.end_date
              : null,
          }
        : null;
    let relativeWidgetDuration = null;
    // to relative date value set
    // if (widget_duration?.from) {
    //   let diff_in_hours = moment(widget_duration?.to).diff(
    //     moment(widget_duration?.from),
    //     "hours",
    //     true
    //   );
    //   if (diff_in_hours <= 24) {
    //     widget_duration.relative = { value: diff_in_hours, type: "Hours" };
    //   }
    // }
    let template_duration =
      type === "advance_settings"
        ? templateDetails?.advance_duration?.from
        : templateDetails?.templateDuration?.from;
    let template_section_duration =
      Section &&
      editPanelInfo?.type === "template_section" &&
      editPanelInfo?.section_index >= 0 &&
      Section[editPanelInfo?.section_index]?.duration;
    // to relative date value set
    // if (template_section_duration?.from) {
    //   let diff_in_hours = moment(template_section_duration?.to).diff(
    //     moment(template_section_duration?.from),
    //     "hours",
    //     true
    //   );
    //   if (diff_in_hours <= 24) {
    //     template_section_duration.relative = {
    //       value: diff_in_hours,
    //       type: "Hours",
    //     };
    //   }
    // }

    let template_widget_duration =
      editPanelInfo?.type === "template_widget" &&
      editPanelInfo?.section_index >= 0 &&
      editPanelInfo?.widget_index >= 0 &&
      Section?.[editPanelInfo?.section_index]?.data?.[
        editPanelInfo?.widget_index
      ]?.duration
        ? Section?.[editPanelInfo?.section_index]?.data?.[
            editPanelInfo?.widget_index
          ]?.duration
        : Section?.[editPanelInfo?.section_index]?.data?.[
            editPanelInfo?.widget_index
          ]?.start_date
        ? {
            from: Section?.[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]?.start_date,
            to: Section?.[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]?.end_date,
          }
        : null;
    // to relative date value set
    // if (template_widget_duration?.from) {
    //   let diff_in_hours = moment(template_widget_duration?.to).diff(
    //     moment(template_widget_duration?.from),
    //     "hours",
    //     true
    //   );
    //   if (diff_in_hours <= 24) {
    //     template_widget_duration.relative = {
    //       value: diff_in_hours,
    //       type: "Hours",
    //     };
    //   }
    // }
    let graphDetailDuration = graphDetail?.duration;

    let splitDuration = graphDetail?.split?.columns;

    let orm_duration = ormDate;
    if (type === "global_dashboard" && !global_duration) {
      let durationObject = {
        type: type,
        value: null,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setGlobalDateValue(durationObject));
    } else if (type === "global_dashboard" && global_duration) {
      let globalDuration = deepCopy(global_duration);
      if (
        // panes[index]?.relative_duration?.is_relative ||
        global_duration?.save_as_relative
      ) {
        globalDuration.relative = {
          type: "short",
          value:
            // panes[index]?.relative_duration?.relative_type ||
            global_duration?.relative?.value,
        };
        globalDuration.save_as_relative =
          // panes[index]?.relative_duration?.is_relative ||
          global_duration?.save_as_relative;
      }
      let durationObject = {
        type: type,
        value: globalDuration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setGlobalDateValue(durationObject));
    }
    if (
      dashboardDateFilterObj?.type === "dashboard_section" &&
      (dashboardDateFilterObj?.dateFilters?.length ||
        clearBrandAndDuration?.sectionLevelDuration)
    ) {
      let dateFilterDuration = dashboardDateFilterObj?.dateFilters?.[0]?.columns
        ?.from
        ? dashboardDateFilterObj?.dateFilters?.[0]?.columns
        : null;
      let durationObject = {
        type: type,
        value: clearBrandAndDuration?.sectionLevelDuration
          ? null
          : dateFilterDuration,
        global_duration: global_duration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setSectionDateValue(durationObject));

      //to update dashboardDateFilterObj
      let paneObject = {
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        section_index: editPanelInfo?.section_index,
        duration: clearBrandAndDuration?.sectionLevelDuration
          ? null
          : dateFilterDuration,
        global_duration: global_duration,
        index: index,
      };
      dispatch(updateSectionDuration(paneObject));
    } else if (type === "dashboard_section" && !section_duration?.from) {
      let durationObject = {
        type: type,
        global_duration: global_duration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setSectionDateValue(durationObject));
      //to update dashboardDateFilterObj
      let paneObject = {
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        section_index: editPanelInfo?.section_index,
        duration: null,
        global_duration: global_duration,
        index: index,
      };
      dispatch(updateSectionDuration(paneObject));
    } else if (type === "dashboard_section" && section_duration?.from) {
      let sectionDuration = deepCopy(section_duration);
      if (
        panes[index]?.sections &&
        panes[index]?.sections[editPanelInfo?.section_index]?.relative_duration
          ?.is_relative
      ) {
        sectionDuration.relative = {
          type: "short",
          value:
            panes[index]?.sections[editPanelInfo?.section_index]
              ?.relative_duration?.relative_type,
        };
        sectionDuration.save_as_relative =
          panes[index]?.sections[
            editPanelInfo?.section_index
          ]?.relative_duration?.is_relative;
      }
      let durationObject = {
        type: type,
        value: sectionDuration,
        global_duration: global_duration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setSectionDateValue(durationObject));

      //to update dashboardDateFilterObj
      let paneObject = {
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        section_index: editPanelInfo?.section_index,
        duration: sectionDuration,
        global_duration: global_duration,
        index: index,
      };
      dispatch(updateSectionDuration(paneObject));
    }

    if (
      dashboardDateFilterObj?.type === "dashboard_widget" &&
      (dashboardDateFilterObj?.dateFilters?.length ||
        clearBrandAndDuration?.widgetLevelDuration)
    ) {
      let dateFilterDuration = dashboardDateFilterObj?.dateFilters?.[0]?.columns
        ?.from
        ? dashboardDateFilterObj?.dateFilters?.[0]?.columns
        : null;
      let durationObject = {
        type: type,
        value: clearBrandAndDuration?.widgetLevelDuration
          ? null
          : dateFilterDuration,
        global_duration: global_duration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setWidgetDateValue(durationObject));

      //to update dashboardDateFilterObj
      let paneObject = {
        index: index,
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        duration: clearBrandAndDuration?.widgetLevelDuration
          ? null
          : dateFilterDuration,
        section_index: editPanelInfo?.section_index,
        widget_index: editPanelInfo?.widget_index,
        global_duration: global_duration,
      };
      dispatch(updateWidgetDuration(paneObject));
    } else if (type === "dashboard_widget" && !widget_duration?.from) {
      let durationObject = {
        type: type,
        global_duration: global_duration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setWidgetDateValue(durationObject));

      //to update dashboardDateFilterObj
      let paneObject = {
        index: index,
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        duration: null,
        section_index: editPanelInfo?.section_index,
        widget_index: editPanelInfo?.widget_index,
        global_duration: global_duration,
      };
      dispatch(updateWidgetDuration(paneObject));
    } else if (type === "dashboard_widget" && widget_duration?.from) {
      let widgetDuration = deepCopy(widget_duration);
      if (
        panes[index]?.sections &&
        panes[index]?.sections[editPanelInfo?.section_index]?.widgets[
          editPanelInfo?.widget_index
        ]?.relative_duration?.is_relative
      ) {
        widgetDuration.relative = {
          type: "short",
          value:
            panes[index]?.sections[editPanelInfo?.section_index]?.widgets[
              editPanelInfo?.widget_index
            ]?.relative_duration?.relative_type,
        };
        widgetDuration.save_as_relative =
          panes[index]?.sections[editPanelInfo?.section_index]?.widgets[
            editPanelInfo?.widget_index
          ]?.relative_duration?.is_relative;
      } else if (
        panes[index]?.section &&
        panes[index]?.section[0]?.widgets[editPanelInfo?.widget_index]
          ?.relative_duration?.is_relative
      ) {
        widgetDuration.relative = {
          type: "short",
          value:
            panes[index]?.section[0]?.widgets[editPanelInfo?.widget_index]
              ?.relative_duration?.relative_type,
        };
        widgetDuration.save_as_relative =
          panes[index]?.section[0]?.widgets[
            editPanelInfo?.widget_index
          ]?.relative_duration?.is_relative;
      }
      let durationObject = {
        type: type,
        value: widgetDuration,
        global_duration: global_duration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setWidgetDateValue(durationObject));

      //to update dashboardDateFilterObj
      let paneObject = {
        index: index,
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        duration: widgetDuration,
        section_index: editPanelInfo?.section_index,
        widget_index: editPanelInfo?.widget_index,
        global_duration: global_duration,
      };
      dispatch(updateWidgetDuration(paneObject));
    }
    if (type === "template_global" && !template_duration) {
      let durationObject = {
        type: type,
        value: null,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setGlobalDateValue(durationObject));
    } else if (type === "template_global" && template_duration) {
      let durationObject = {
        type: type,
        value: templateDetails?.templateDuration,

        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setGlobalDateValue(durationObject));
    }

    if (type === "advance_settings" && !template_duration) {
      let durationObject = {
        type: type,
        value: null,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setGlobalDateValue(durationObject));
    } else if (type === "advance_settings" && template_duration) {
      let advanceDuration = deepCopy(templateDetails?.advance_duration);
      if (templateDetails?.advance_duration?.save_as_relative) {
        advanceDuration.relative = {
          type: "short",
          value: templateDetails?.advance_duration?.relative?.value,
        };
        advanceDuration.save_as_relative =
          templateDetails?.advance_duration?.save_as_relative;
      }
      let durationObject = {
        type: type,
        value: advanceDuration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setGlobalDateValue(durationObject));
    }
    if (type === "template_section" && !template_section_duration) {
      let durationObject = {
        type: type,
        global_duration: templateDetails?.templateDuration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setSectionDateValue(durationObject));
    } else if (type === "template_section" && template_section_duration) {
      let sectionDuration = deepCopy(template_section_duration);
      if (
        Section &&
        editPanelInfo?.section_index >= 0 &&
        Section[editPanelInfo?.section_index]?.relative_duration?.is_relative
      ) {
        sectionDuration.relative = {
          type: "short",
          value:
            Section[editPanelInfo?.section_index]?.relative_duration
              ?.relative_type,
        };
        sectionDuration.save_as_relative =
          Section[editPanelInfo?.section_index]?.relative_duration?.is_relative;
      }
      let durationObject = {
        type: type,
        value: sectionDuration,
        global_duration: templateDetails?.templateDuration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setSectionDateValue(durationObject));
    }
    if (type === "template_widget" && !template_widget_duration) {
      let durationObject = {
        type: type,
        global_duration: templateDetails?.templateDuration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setWidgetDateValue(durationObject));
    } else if (type === "template_widget" && template_widget_duration) {
      let widgetDuration = deepCopy(template_widget_duration);
      if (
        Section &&
        editPanelInfo?.section_index >= 0 &&
        editPanelInfo?.widget_index >= 0 &&
        Section[editPanelInfo?.section_index]?.data?.[
          editPanelInfo?.widget_index
        ]?.relative_duration?.is_relative
      ) {
        widgetDuration.relative = {
          type: "short",
          value:
            Section[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]?.relative_duration?.relative_type,
        };
        widgetDuration.save_as_relative =
          Section[editPanelInfo?.section_index]?.data?.[
            editPanelInfo?.widget_index
          ]?.relative_duration?.is_relative;
      }
      let durationObject = {
        type: type,
        value: widgetDuration,
        global_duration: templateDetails?.templateDuration,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setWidgetDateValue(durationObject));
    } else if (type === "graph_page") {
      let durationObject;
      if (graphDetailDuration) {
        durationObject = {
          type: type,
          value: graphDetailDuration,
          dateValue: dateValue,
          timeValue: timeValue,
        };
      } else if (templateDetails?.templateDuration?.from) {
        //for carryforwarding the global duration
        dispatch(
          setGraphDuration(templateDetails?.templateDuration, graphDetail)
        );
        durationObject = {
          type: type,
          value: templateDetails?.templateDuration,
          dateValue: dateValue,
          timeValue: timeValue,
        };
      } else {
        durationObject = {
          type: type,

          dateValue: dateValue,
          timeValue: timeValue,
        };
      }

      dispatch(setGraphPageDateValue(durationObject));
    } else if (type === "preview") {
      let durationObject;
      if (previewDate) {
        durationObject = {
          type: type,
          value: previewDate,
          dateValue: dateValue,
          timeValue: timeValue,
        };
      } else {
        durationObject = {
          type: type,

          dateValue: dateValue,
          timeValue: timeValue,
        };
      }

      dispatch(setGraphPageDateValue(durationObject));
    } else if (type === "schedule_duration") {
      let durationObject;
      if (scheduleObj?.startDate && scheduleObj?.IsScheduled) {
        let obj = { from: scheduleObj?.startDate, to: scheduleDate?.endDate };
        durationObject = {
          type: type,
          value: obj,
          dateValue: dateValue,
          timeValue: timeValue,
        };
      } else {
        durationObject = {
          type: type,

          dateValue: dateValue,
          timeValue: timeValue,
        };
      }

      dispatch(setGraphPageDateValue(durationObject));
    } else if (type === "schedule_date_time") {
      let durationObject;

      if (scheduleObj?.startDate && !scheduleObj?.IsScheduled) {
        let obj = {
          from: scheduleObj?.startDate,
          to: scheduleObj?.endDate,
          relative: scheduleObj?.relativeCount
            ? scheduleObj?.relativeCount
            : null,
        };
        if (scheduleObj?.relative_duration?.is_relative) {
          obj.relative = {
            type: "short",
            value: scheduleObj?.relative_duration?.relative_type,
          };
        }
        durationObject = {
          type: type,
          value: obj,
          dateValue: dateValue,
          timeValue: timeValue,
        };
      } else {
        durationObject = {
          type: type,

          dateValue: dateValue,
          timeValue: timeValue,
        };
      }

      dispatch(setGraphPageDateValue(durationObject));
    } else if (type === "orm_dashboard") {
      let durationObject;
      if (orm_duration) {
        durationObject = {
          type: type,
          value: orm_duration,
          dateValue: dateValue,
          timeValue: timeValue,
        };
      } else {
        durationObject = {
          type: type,

          dateValue: dateValue,
          timeValue: timeValue,
        };
      }

      // dispatch(setGraphPageDateValue(durationObject));
      dispatch(setOrmDateValue(durationObject));
    } else if (type === "split") {
      // basic condition for split when split is not applied
      let dateObj = getCustomizedDate(6, "Days");
      const dates = getThreeSplitDate(
        [
          graphDetailDuration
            ? moment(graphDetailDuration?.from).format("YYYY/MM/DD HH:MM")
            : moment(dateObj?.date[0]).format("YYYY/MM/DD HH:MM"),
          graphDetailDuration
            ? moment(graphDetailDuration?.to).format("YYYY/MM/DD HH:MM")
            : moment(dateObj?.date[1]).format("YYYY/MM/DD HH:MM"),
        ],
        graphDetailDuration
          ? moment(graphDetailDuration?.from).format("YYYY/MM/DD HH:MM")
          : moment(dateObj?.date[0]).format("YYYY/MM/DD HH:MM"),
        graphDetailDuration
          ? moment(graphDetailDuration?.to).format("YYYY/MM/DD HH:MM")
          : moment(dateObj?.date[1]).format("YYYY/MM/DD HH:MM")
      );

      let splitDates =
        splitDuration?.length > 0
          ? {
              defaultDate1: [splitDuration[0]?.from, splitDuration[0]?.to],
              defaultDate2: [splitDuration[1]?.from, splitDuration[1]?.to],
              defaultDate3:
                splitDuration?.length === 3
                  ? [splitDuration[2]?.from, splitDuration[2]?.to]
                  : dates?.defaultDate3,
            }
          : dates;

      let durationObject = {
        type: type,
        value: splitDates,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setSplitDateValue(durationObject));

      if (type === "split" && split === "one") {
        let check1 = check ? { ...check } : {};
        check1.one = checked ? true : false;
        setcheck(check1);
      } else if (type === "split" && split === "two") {
        let check1 = check ? { ...check } : {};
        check1.two = checked ? true : false;
        setcheck(check1);
      } else if (type === "split" && split === "three") {
        let check1 = check ? { ...check } : {};
        check1.three = checked ? true : false;
        setcheck(check1);
      }
    } else if (type === "share_modal") {
      let durationObject;
      if (sharedDuration) {
        // to relative date value set
        // if (sharedDuration?.from) {
        //   let diff_in_hours = moment(sharedDuration?.to).diff(
        //     moment(sharedDuration?.from),
        //     "hours",
        //     true
        //   );
        //   if (diff_in_hours <= 24) {
        //     sharedDuration.relative = {
        //       value: diff_in_hours,
        //       type: "Hours",
        //     };
        //   }
        // }
        let shared_duration;
        if (shareTemplateData?.relative_duration?.is_relative) {
          shared_duration = deepCopy(sharedDuration);
          shared_duration.relative = {
            type: "short",
            value: shareTemplateData?.relative_duration?.relative_type,
          };
          shared_duration.save_as_relative =
            shareTemplateData?.relative_duration?.is_relative;
        }
        durationObject = {
          type: type,
          value: shared_duration ? shared_duration : sharedDuration,
          dateValue: dateValue,
          timeValue: timeValue,
        };
      } else {
        durationObject = {
          type: type,

          dateValue: dateValue,
          timeValue: timeValue,
        };
      }
      dispatch(setOrmDateValue(durationObject));
    } else if (type === "widgetMaker") {
      let durationObject;
      if (widgetMakerDuration?.from) {
        durationObject = {
          type: type,
          value: widgetMakerDuration,
          dateValue: dateValue,
          timeValue: timeValue,
        };
      } else {
        durationObject = {
          type: type,

          dateValue: dateValue,
          timeValue: timeValue,
        };
      }
      dispatch(setOrmDateValue(durationObject));
    } else if (type === "CommandCenter") {
      let durationObject;
      if (screen?.duration?.from) {
        durationObject = {
          type: type,
          value: screen?.duration,
          dateValue: dateValue,
          timeValue: timeValue,
        };
      } else {
        durationObject = {
          type: type,
          dateValue: dateValue,
          timeValue: timeValue,
        };
      }
      dispatch(setCommandCenterDateValue(durationObject));
    }
  };

  // Created new useEffect to open duration modal in case of custom duration of CC
  useEffect(() => {
    if (
      !datePicker &&
      authParams?.screen_id &&
      screen?.selected_duration_type === "Custom" &&
      screen?.selected_duration_type_flag
    ) {
      setDatepicker(true);
    }
  }, []);

  useEffect(() => {
    //useeffect for setting localTime & localDate whenever timeValue or timeValue is updated

    if (type === "split" && split === "one") {
      setlocalDate(dateValue[type]?.data?.one);
      setlocalTime(timeValue[type]?.data?.one);
    } else if (type === "split" && split === "two") {
      setlocalDate(dateValue[type]?.data?.two);
      setlocalTime(timeValue[type]?.data?.two);
    } else if (type === "split" && split === "three") {
      setlocalDate(dateValue[type]?.data?.three);
      setlocalTime(timeValue[type]?.data?.three);
    } else if (
      dateValue &&
      (type === "global_dashboard" ||
        type === "dashboard_section" ||
        type === "dashboard_widget" ||
        type === "template_global" ||
        type === "template_section" ||
        type === "template_widget" ||
        type === "advance_settings" ||
        type === "schedule_duration" ||
        type === "schedule_date_time" ||
        type === "widgetMaker" ||
        type === "preview" ||
        type === "share_modal" ||
        type === "orm_dashboard" ||
        type === "graph_page")
    ) {
      if (dateValue[type]?.data) {
        setlocalDate(dateValue[type]?.data);
      } else {
        setlocalDate(getCustomizedDate(6, "Days")?.date);
      }
      if (timeValue[type]?.data) {
        setlocalTime(timeValue[type]?.data);
      } else {
        setlocalTime(getCustomizedDate(6, "Days")?.time);
      }
    } else if (type === "CommandCenter") {
      if (dateValue[type]?.data) {
        setlocalDate(dateValue[type]?.data);
      } else {
        setlocalDate(getCustomizedDate(0, "Days")?.date);
      }
      if (timeValue[type]?.data) {
        setlocalTime(timeValue[type]?.data);
      } else {
        setlocalTime(getCustomizedDate(0, "Days")?.time);
      }
    }
  }, [dateValue, timeValue]);

  const onCancel = (e) => {
    if (authParams?.screen_id && screen?.selected_duration_type === "Custom") {
      dispatch(setSelectedDurationTypeFlag(false));
    }

    //when datetime component is closed
    setDatepicker(false);
    settimeFlag([
      { type: "start", data: { value: false, msg: null } },
      { type: "end", data: { value: false, msg: null } },
    ]);
    e && resetState();
    dispatch(
      setDateTimeFlag({
        flag: false,
        msg: null,
      })
    );
  };
  const onOpen = (e) => {
    //when datetime component is opened
    if (refDate.current && !refDate.current.contains(e.target)) {
      setDatepicker(false);
    } else {
      setDatepicker(true);
    }
    // let gethtml = document.getElementById("Duration");
    // let getId = e?.target?.id;
    // if (gethtml && getId) {
    //   if (getId == gethtml?.id) {
    //     if (e.clientY < 432) {
    //       setPositiony({
    //         top: e.clientY - 20 + "px",
    //         left:
    //           type === "widgetMaker"
    //             ? e.clientX - 100 + "px"
    //             : scheduleReport
    //             ? "auto"
    //             : "auto",
    //         bottom: "700px",
    //         right: scheduleReport ? "auto" : e.clientY,
    //       });
    //     } else {
    //       setPositiony({
    //         top: "40px",
    //         left: e.clientX / 2 + "px",
    //         right: "auto",
    //       });
    //     }
    //   }
    // }
  };

  // useEffect(() => {
  //   // document.addEventListener("click", onOpen, true);
  //   document.addEventListener("scroll", onOpen, true);
  //   return () => {
  //    // document.removeEventListener("click", onOpen, true);
  //      document.removeEventListener("scroll", onOpen, true);
  //   };
  // }, []);

  const onDoneButtonChecks = () => {
    let date =
      type === "split" && split === "one"
        ? dateValue[type]?.data?.one
        : type === "split" && split === "two"
        ? dateValue[type]?.data?.two
        : type === "split" && split === "three"
        ? dateValue[type]?.data?.three
        : dateValue[type]?.data
        ? dateValue[type]?.data
        : getCustomizedDate(6, "Days")?.date;
    let sameDate =
      moment(date[0]).format("YYYY/MM/DD") ===
      moment(date[1]).format("YYYY/MM/DD");
    let currentSameDate =
      moment(date[0]).format("YYYY/MM/DD") ===
        moment(date[1]).format("YYYY/MM/DD") &&
      moment(new Date()).format("YYYY/MM/DD") ===
        moment(date[0]).format("YYYY/MM/DD") &&
      moment(date[0]).format("YYYY/MM/DD") !== null;
    let currentEndDate =
      moment(date[1]).format("YYYY/MM/DD") ===
      moment(new Date()).format("YYYY/MM/DD");

    return checkTimeValidity(currentSameDate, sameDate, currentEndDate);
  };

  const checkTimeValidity = (currentSameDate, sameDate, currentEndDate) => {
    //time value obj

    let value =
      type === "split" && split === "one"
        ? timeValue[type]?.data?.one
        : type === "split" && split === "two"
        ? timeValue[type]?.data?.two
        : type === "split" && split === "three"
        ? timeValue[type]?.data?.three
        : timeValue[type]?.data
        ? timeValue[type]?.data
        : getCustomizedDate(6, "Days")?.time;
    let flag = false;
    let timeObj = [
      { type: "start", data: { value: false, msg: null } },
      { type: "end", data: { value: false, msg: null } },
    ];
    //condition for start & end today's date and start time is > current time
    if (
      currentSameDate &&
      value?.startTime > moment(new Date()).format("HH:mm")
    ) {
      timeObj[0].data.value = true;
      timeObj[0].data.msg = "Start time cannot be greater than current time.";
      settimeFlag(timeObj);

      flag = true;
    }
    if (sameDate && !currentSameDate && value?.startTime > value?.endTime) {
      flag = true;
      timeObj[0].data.value = true;
      timeObj[0].data.msg = "Start time cannot be greater than end time!";
      settimeFlag(timeObj);
    }

    if (sameDate && value?.startTime == value?.endTime) {
      flag = true;
      timeObj[0].data.value = true;
      timeObj[0].data.msg = "Please change the timing! It cannot be same.";
      settimeFlag(timeObj);
    }
    if (
      type === "schedule_date_time" &&
      currentEndDate &&
      value?.endTime > moment(new Date()).format("HH:mm")
    ) {
      flag = true;
      timeObj[0].data.value = true;
      timeObj[0].data.msg = "End time cannot be more than current time.";
      settimeFlag(timeObj);
    }
    return flag;
  };

  const onDoneButton = (checked_type) => {
    type === "split" && setChecked(true);
    let value =
      type === "split" && checked_type === "one"
        ? timeValue[type]?.data?.one
        : split === "one"
        ? timeValue[type]?.data?.one
        : type === "split" && checked_type === "two"
        ? timeValue[type]?.data?.two
        : split === "two"
        ? timeValue[type]?.data?.two
        : type === "split" && checked_type === "three"
        ? timeValue[type]?.data?.three
        : split === "three"
        ? timeValue[type]?.data?.three
        : timeValue[type]?.data
        ? timeValue[type]?.data
        : getCustomizedDate(6, "Days")?.time;
    let needToUpdateLabelValue = false;
    if (!timeValue[type]?.data) {
      needToUpdateLabelValue = true;
    }
    let Diff_in_days = setDiffInDays(localDate);
    let currentSameDate = localDate
      ? moment(localDate[0]).format("YYYY/MM/DD") ===
          moment(localDate[1]).format("YYYY/MM/DD") &&
        moment(new Date()).format("YYYY/MM/DD") ===
          moment(localDate[0]).format("YYYY/MM/DD") &&
        moment(localDate[0]).format("YYYY/MM/DD") !== null
      : null;

    let obj = localDate
      ? {
          days: currentSameDate ? "Today" : Diff_in_days,
          from:
            moment(localDate[0]).format("YYYY/MM/DD") + " " + value.startTime,
          to: moment(localDate[1]).format("YYYY/MM/DD") + " " + value?.endTime,
          relative: localDate?.["relative"]
            ? localDate?.["relative"]
            : localDate?.relative,
          save_as_relative: keepAsRelative,
        }
      : null;
    let timeCheck = onDoneButtonChecks();
    let handler;
    //when user does not change date manually, just click the done btn
    if (!timeCheck) {
      if (type === "global_dashboard") {
        let index = getPaneIndex(panes, activeKey);

        let paneObject = {
          duration: obj,
          panes: panes,
          activeKey: activeKey,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          authParams: authParams,
          singleBrands: brands,
          index: index,
          competitorBrands: competitorBrands,
          graphConditionConfig: graphConditionConfig,
          temporary_words: temporary_words,
          is_modified_date:
            panes?.[index]?.template_id === "000-000-002" ||
            panes?.[index]?.template_id === "000-000-004"
              ? panes?.[index]?.is_modified_date
                ? panes?.[index]?.is_modified_date
                : false
              : null,
        };
        dispatch(updateDashboardDuration(paneObject));

        // console.log("check here", panes[index]?.quick_filter)
        if (panes?.[index]?.quick_filter !== "CampaignID") {
          // do not update in case of campaign dashboard
          dispatch(setGlobalDuration(obj));
        }

        // Handling Ticket Overview Duration
        let getInterval = getTimeInterval(obj.to, obj.from);

        dispatch(setTicketOverviewWidget1(getInterval?.defaultVal));
        dispatch(setTicketOverviewWidget2(getInterval?.defaultVal));
        dispatch(setTicketOverviewInterval(getInterval?.defaultVal));
        dispatch(
          setSocialMediaDropdownOptions({
            widget3: getInterval?.defaultVal,
            widget5: getInterval?.defaultVal,
            widget7: getInterval?.defaultVal,
            widget11: getInterval?.defaultVal,
            widget13: getInterval?.defaultVal,
          })
        );

        // to set global selected widget in redux state to scroll that widget
        dispatch(setGlobalSelectedWidgetId(visitedWidgetId));
        // to clear deep dive selected widget
        dispatch(setSelectedDeepdiveWidget(null, null, panes, index));
      } else if (type === "dashboard_section" && editPanelInfo) {
        if (needToUpdateLabelValue) {
          let durationObject = {
            type: type,
            value: obj,
            dateValue: dateValue,
            timeValue: timeValue,
          };
          dispatch(setSectionDateValue(durationObject));
          dispatch(
            setClearBrandAndDuration({
              ...clearBrandAndDuration,
              sectionLevelDuration: false,
            })
          );
        }
        let index = getPaneIndex(panes, activeKey);
        let global_duration = panes[index].duration;

        let paneObject = {
          panes: panes,
          activeKey: activeKey,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          authParams: authParams,
          section_index: editPanelInfo?.section_index,
          duration: obj,
          global_duration: global_duration,
          index: index,
        };

        dispatch(updateSectionDuration(paneObject));
      } else if (type === "dashboard_widget" && editPanelInfo) {
        if (needToUpdateLabelValue) {
          let durationObject = {
            type: type,
            value: obj,
            dateValue: dateValue,
            timeValue: timeValue,
          };
          dispatch(setWidgetDateValue(durationObject));
          dispatch(
            setClearBrandAndDuration({
              ...clearBrandAndDuration,
              widgetLevelDuration: false,
            })
          );
        }
        let index = getPaneIndex(panes, activeKey);
        let global_duration = panes[index].duration;

        let paneObject = {
          index: index,
          panes: panes,
          activeKey: activeKey,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          authParams: authParams,
          duration: obj,
          section_index: editPanelInfo?.section_index,
          widget_index: editPanelInfo?.widget_index,
          global_duration: global_duration,
        };

        dispatch(updateWidgetDuration(paneObject));
      } else if (type === "template_global") {
        let templateObject = {
          duration: obj,
          selectBrands: templateDetails?.templateBrands?.columns
            ? templateDetails?.templateBrands?.columns?.length > 0
              ? templateDetails?.templateBrands?.columns
              : null
            : templateDetails?.templateBrands?.length
            ? templateDetails?.templateBrands
            : null,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          authParams: authParams,
          templateDetails: templateDetails,
          section: Section,
          filters: templateDetails?.templateFilters
            ? templateDetails?.templateFilters
            : [],
          type: type,
          change_type: "global_duration",
          graphConditionConfig: graphConditionConfig,
        };
        dispatch(
          setTemplateDetails(templateDetails, {
            duration: obj,
            dashboard_called_api_list: [],
          })
        );
        //to carryforward create/edit template date to graph page date
        dispatch(setGraphDuration(obj, graphDetail));

        // we are call api through getTemplateFilter, so here we stop previous api calls because here we perform global level changes
        window?.stop();
        dispatch(setTemplateFilter(templateObject));
        dispatch(setGlobalDuration(obj));
      } else if (type === "advance_settings") {
        let index = getPaneIndex(panes, activeKey);

        let paneObject = {
          duration: obj,
          panes: panes,
          activeKey: activeKey,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          authParams: authParams,
          singleBrands: brands,
          index: index,
        };
        dispatch(
          setTemplateDetails(templateDetails, {
            advance_duration: obj,
          })
        );
        dispatch(setPaneDuration(paneObject, "global_dashboard"));
      } else if (type === "template_section") {
        let templateObj1 = {
          section: Section,
          templateDetails: templateDetails,
          section_index: editPanelInfo?.section_index,
          authParams: authParams,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          duration: templateDetails?.templateDuration, //for graph fetch global duration
          durationObj: obj,
        };
        dispatch(setSectionDuration(templateObj1));
        let global = templateDetails?.templateFilters
          ? templateDetails?.templateFilters
          : [];

        let global_brands = templateDetails?.templateBrands
          ? templateDetails?.templateBrands
          : null;
        let global_duration = templateDetails?.templateDuration
          ? templateDetails?.templateDuration
          : null;

        let templateObj = {
          section: Section,
          templateDetails: templateDetails,
          section_index: selectedSection?.section_index,
          authParams: authParams,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          global_brands: selectedSection?.is_locked
            ? templateBrandObj?.selectBrands
              ? templateBrandObj?.selectBrands
              : Section[selectedSection?.section_index]?.brandFilters
            : global_brands,
          filters: Section[selectedSection?.section_index]?.onlyFilters,
          duration: selectedSection?.is_locked
            ? obj
              ? obj
              : Section[selectedSection?.section_index]?.dateFilters
              ? Section[selectedSection?.section_index]?.dateFilters
              : global_duration
            : global_duration,
          is_locked: selectedSection?.is_locked,
          brandFilters:
            //  templateBrandObj?.selectBrands
            // ? templateBrandObj?.selectBrands
            // :
            Section[selectedSection?.section_index]?.brandFilters,
          dateFilters: obj
            ? obj
            : Section[selectedSection?.section_index]?.dateFilters,
          clear: false,
        };

        dispatch(setTemplateSectionFilter(templateObj, false));

        let obj1 = {
          type: "template_section",
          filters: global,
          section: Section,
          brands: templateDetails?.brands
            ? templateDetails?.brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands,
          authParams: authParams,
          duration: templateDetails?.templateDuration
            ? templateDetails?.templateDuration
            : null,
          currentFilter: value ? value : [],
          graphConditionConfig: graphConditionConfig,
        };
        dispatch(setIsWidgetEdit(false));
        dispatch(setIsNetworkWidgetSettingEdit(false));
        dispatch(setNetworkWidgetSettingObject(null));

        dispatch(setTemplateFilter(obj1, templateObj));
      } else if (type === "template_widget") {
        let widget_metadata =
          editPanelInfo?.section_index >= 0
            ? Section?.[editPanelInfo?.section_index]?.data?.[
                editPanelInfo?.widget_index
              ]
            : Section?.[0]?.data?.[editPanelInfo?.widget_index];

        let section_metadata =
          editPanelInfo?.section_index >= 0
            ? Section?.[editPanelInfo?.section_index]
            : Section?.[0];

        let templateObj1 = {
          section: Section,
          templateDetails: templateDetails,
          section_index: editPanelInfo?.section_index,
          authParams: authParams,
          widget_index: editPanelInfo?.widget_index,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          duration: templateDetails?.templateDuration,
          durationObj: obj,
        };
        dispatch(setWidgetDuration(templateObj1));
        let global = templateDetails?.templateFilters
          ? templateDetails?.templateFilters
          : [];

        let global_brands = templateDetails?.templateBrands
          ? templateDetails?.templateBrands
          : null;

        let global_duration = templateDetails?.templateDuration
          ? templateDetails?.templateDuration
          : null;

        let res = null;
        let newSection = deepCopy(Section);
        let updatedSection = null;
        let currectSection = deepCopy(Section?.[editPanelInfo?.section_index]);
        let forParticularSection = {
          section_index: selectedSection?.section_index
            ? selectedSection?.section_index
            : 0,
          section_id: currectSection?.id,
          widget_id: selectedSection?.id,
          widget_index: selectedSection?.widget_index,
        };
        // if dupliates widget exists and global brand is competitor then need split again
        let secLockedOnBrand =
          currectSection?.is_locked &&
          currectSection?.brands &&
          currectSection?.brands?.length > 0 &&
          (currectSection?.brands?.[0]?.columns?.length > 0
            ? !currectSection?.brands?.[0]?.columns?.[0]?.competitor
            : !currectSection?.brands?.[0]?.competitor);
        let comBrandtypeExists =
          currectSection?.comp_brand_type === false ||
          currectSection?.comp_brand_type === true
            ? true
            : false;
        let currectWidget =
          currectSection?.data && currectSection?.data?.length > 0
            ? currectSection?.data?.[selectedSection?.widget_index]
            : currectSection?.widgets?.[selectedSection?.widget_index];
        let widgetLockedOnBrand =
          selectedSection?.is_locked &&
          currectWidget?.brands?.length > 0 &&
          (currectWidget?.brands?.[0]?.columns
            ? !currectWidget?.brands?.[0]?.columns?.[0]?.competitor
            : !currectWidget?.brands?.[0]?.competitor);
        let comBrand = global_brands?.columns?.[0]?.competitor
          ? global_brands?.columns?.[0]
          : global_brands?.[0]?.competitor
          ? global_brands?.[0]
          : global_brands?.competitor
          ? global_brands
          : null;
        if (
          comBrand &&
          !secLockedOnBrand &&
          !comBrandtypeExists &&
          !widgetLockedOnBrand &&
          currectWidget?.chart &&
          currectWidget?.chart?.["chart_settings"]["duplicate_for_brands"]
        ) {
          res = checkForDuplicateWidgets(newSection, forParticularSection);
          if (res?.parentExists) {
            let filterSectionData = getFilterDuplicateWidgets(
              newSection,
              forParticularSection
            );
            if (filterSectionData !== null) {
              let iOfW = filterSectionData?.[
                forParticularSection?.section_index
              ]?.data?.length
                ? filterSectionData?.[
                    forParticularSection?.section_index
                  ]?.data?.findIndex(
                    (el) => el?.widget_id === forParticularSection?.widget_id
                  )
                : filterSectionData?.[
                    forParticularSection?.section_index
                  ]?.widgets?.findIndex(
                    (el) => el?.widget_id === forParticularSection?.widget_id
                  );
              if (iOfW !== -1) {
                // if (
                //   filterSectionData?.[forParticularSection?.section_index]?.data
                //     ?.length
                // ) {
                //   filterSectionData[forParticularSection?.section_index].data[
                //     iOfW
                //   ] = currectWidget; // need to assign updated widget metadata
                // } else {
                //   filterSectionData[forParticularSection?.section_index].widgets[
                //     iOfW
                //   ] = currectWidget; // need to assign updated widget metadata
                // }
              }
              let newBrandList = [];
              newBrandList.push({
                brand_id: comBrand?.name,
                brand_name: comBrand?.brand_name,
                brand_friendly_name: comBrand?.brand_friendly_name,
              });
              comBrand?.competitorList?.forEach((competitorBrand) => {
                newBrandList.push(competitorBrand);
              });
              updatedSection = splitSectionWidgets(
                filterSectionData,
                newBrandList,
                brands
              );
            }
          } else if (res?.duplicateExists) {
            let newBrandList = [];
            newBrandList.push({
              brand_id: comBrand?.name,
              brand_name: comBrand?.brand_name,
              brand_friendly_name: comBrand?.brand_friendly_name,
            });
            comBrand?.competitorList?.forEach((competitorBrand) => {
              newBrandList.push(competitorBrand);
            });
            updatedSection = splitSectionWidgets(
              newSection,
              newBrandList,
              brands
            );
          }
        } else if (
          currectWidget?.chart &&
          currectWidget?.chart?.["chart_settings"]["duplicate_for_brands"]
        ) {
          res = checkForDuplicateWidgets(newSection, forParticularSection);
          if (res?.parentExists) {
            let filterSectionData = getFilterDuplicateWidgets(
              newSection,
              forParticularSection
            );
            if (filterSectionData !== null) {
              let iOfW = filterSectionData?.[
                forParticularSection?.section_index
              ]?.data?.length
                ? filterSectionData?.[
                    forParticularSection?.section_index
                  ]?.data?.findIndex(
                    (el) => el?.widget_id === forParticularSection?.widget_id
                  )
                : filterSectionData?.[
                    forParticularSection?.section_index
                  ]?.widgets?.findIndex(
                    (el) => el?.widget_id === forParticularSection?.widget_id
                  );
              if (iOfW !== -1) {
                // if (
                //   filterSectionData?.[forParticularSection?.section_index]?.data
                //     ?.length
                // ) {
                //   filterSectionData[forParticularSection?.section_index].data[
                //     iOfW
                //   ] = currectWidget; // need to assign updated widget metadata
                // } else {
                //   filterSectionData[forParticularSection?.section_index].widgets[
                //     iOfW
                //   ] = currectWidget; // need to assign updated widget metadata
                // }
              }
              updatedSection = filterSectionData;
            }
          }
        }
        let needToBeUpdateSectionAllWidgetsWithId = null;
        if (
          res &&
          (res?.duplicateExists || res?.parentExists) &&
          updatedSection
        ) {
          Section[editPanelInfo?.section_index] =
            updatedSection?.[editPanelInfo?.section_index];
          needToBeUpdateSectionAllWidgetsWithId = {
            ...forParticularSection,
          };
        }

        let templateObj = {
          section: Section,
          templateDetails: templateDetails,
          section_index: selectedSection?.section_index,
          widget_index: selectedSection?.widget_index,
          authParams: authParams,
          global_brands: selectedSection?.is_locked
            ? templateBrandObj?.selectBrands
              ? templateBrandObj?.selectBrands
              : selectedSection?.section_index
              ? Section[selectedSection?.section_index]?.data[
                  selectedSection?.widget_index
                ]?.brandFilters
              : Section[0]?.data[selectedSection?.widget_index]?.brandFilters
            : global_brands,
          brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
          filters: value
            ? value
            : selectedSection?.section_index
            ? Section[selectedSection?.section_index]?.data[
                selectedSection?.widget_index
              ]?.onlyFilters
            : Section[0]?.data[selectedSection?.widget_index]?.onlyFilters,
          duration: selectedSection?.is_locked
            ? obj
              ? obj
              : Section[selectedSection?.section_index]?.dateFilters
              ? Section[selectedSection?.section_index]?.dateFilters
              : global_duration
            : global_duration,
          is_locked: selectedSection?.is_locked,
          brandFilters:
            // templateBrandObj?.selectBrands
            //   ? templateBrandObj?.selectBrands
            //   :
            selectedSection?.section_index
              ? Section[selectedSection?.section_index]?.data[
                  selectedSection?.widget_index
                ]?.brandFilters
              : Section[0]?.data[selectedSection?.widget_index]?.brandFilters,
          dateFilters: obj
            ? obj
            : selectedSection?.section_index
            ? Section[selectedSection?.section_index]?.data[
                selectedSection?.widget_index
              ]?.dateFilters
            : Section[0]?.data[selectedSection?.widget_index]?.dateFilters,
          clear: false,
          profile_filters: widget_metadata?.profile_filters
            ? widget_metadata?.profile_filters
            : null,
          profile_filters_list:
            widget_metadata?.is_locked && widget_metadata?.profile_filters_list
              ? widget_metadata?.profile_filters_list
              : section_metadata?.brands &&
                section_metadata?.profile_filters_list
              ? section_metadata?.profile_filters_list
              : profileFilterList,
          profile_filters_flag: widget_metadata?.profile_filters_flag,
        };

        dispatch(
          setTemplateWidgetFilter(
            templateObj,
            false,
            null,
            needToBeUpdateSectionAllWidgetsWithId
          )
        );

        let obj1 = {
          type: "template_widget",
          filters: global,
          section: templateObj?.section ? templateObj?.section : Section,
          brands: templateDetails?.brands
            ? templateDetails?.brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands,
          authParams: authParams,
          duration: templateDetails?.templateDuration
            ? templateDetails?.templateDuration
            : null,
          currentFilter: value ? value : [],
          graphConditionConfig: graphConditionConfig,
        };
        dispatch(setIsWidgetEdit(false));
        dispatch(setIsNetworkWidgetSettingEdit(false));
        dispatch(setNetworkWidgetSettingObject(null));
        dispatch(setTemplateFilter(obj1, templateObj));
      } else if (type === "graph_page") {
        graphDetail?.split?.datatype === "datetime"
          ? setIsModalVisible1({ value: true, data: obj })
          : dispatch(setGraphDuration(obj, graphDetail));
      } else if (type === "schedule_duration") {
        const dates = handleScheduleDateChange(
          obj,
          selectedFrequency,
          selectedDataDuration,
          selectedLastXDays,
          scheduleDay,
          scheduleTime,
          scheduleMonth,
          TimeOffsetText
        );
        //write logic here
        dispatch(
          setScheduleReport({
            ...scheduleObj,
            startDate: moment(dates?.startDate)
              .tz(TimeOffsetText.split(" ")[1])
              .format("YYYY-MM-DD HH:mm:ss"),
            endDate: moment(dates?.endDate)
              .tz(TimeOffsetText.split(" ")[1])
              .format("YYYY-MM-DD HH:mm:ss"),
          })
        );
      } else if (type === "schedule_date_time") {
        //write logic here
        const dates = handleGenerateDateChange(obj);
        dispatch(
          setScheduleReport({
            ...scheduleObj,
            startDate: dates?.startDate,
            endDate: dates?.endDate,
            relativeCount: dates?.relative,
            relative_duration: dates?.relative_duration,
          })
        );
      } else if (type === "preview") {
        dispatch(setPrevieDate(obj));
        let graphObject = preview_metadata
          ? {
              ...preview_metadata,
            }
          : {};
        graphObject.start_date = obj?.from;
        graphObject.end_date = obj?.to;
        graphObject.brands = previewBrands
          ? previewBrands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands;
        graphObject.isBrandModified = previewBrands ? true : false;
        graphObject.isWidgetPreview = true;
        graphObject.isNetworkChartV2 =
          graphObject?.chart?.chart_type === "network-graph-v2" ? true : false;
        // graphObject.ticket =
        //   graphObject?.data_source === "ticket" ? true : false;
        // graphObject.campaign =
        //   graphObject?.data_source === "campaign" ? true : false;
        // graphObject.feedback =
        //   graphObject?.data_source === "feedback" ? true : false;
        // graphObject.nps = graphObject?.data_source === "nps" ? true : false;
        // graphObject.page = graphObject?.data_source === "page" ? true : false;
        graphConditionConfig?.[`data-source`]?.includes(
          graphObject?.data_source
        )
          ? dispatch(
              setPageChart(
                authParams,
                graphObject,
                null,
                preview_metadata?.quick_filter
                  ? preview_metadata?.quick_filter
                  : []
              )
            )
          : dispatch(
              setWidgetMakerGraphData(
                authParams,
                graphObject,
                null,
                preview_metadata?.quick_filter
                  ? preview_metadata?.quick_filter
                  : []
              )
            );
      } else if (type === "share_modal") {
        dispatch(setSharedDuration(obj));
        let updatedShareTemplateData = { ...shareTemplateData };
        updatedShareTemplateData.duration = obj?.from
          ? {
              from: obj?.from ? obj?.from : null,
              to: obj?.to ? obj?.to : null,
            }
          : null;
        let shareObj = {
          shareBrands: shareBrands,
          duration: obj,
          shareData: updatedShareTemplateData,
          shareCategory: shareCategory,
          graphConditionConfig: graphConditionConfig,
          change_type: "global_duration",
        };

        dispatch(
          setClearGraphData(
            null,
            null,
            "share",
            shareObj,
            query?.get("share_id")
          )
        );

        // to set global selected widget in redux state to scroll that widget
        dispatch(setGlobalSelectedWidgetId(visitedWidgetId));

        // to clear selected widget deepdive for shared dashboard
        shareBrands && dispatch(setShareSelectedDeepdiveWidget(null));
      } else if (type === "widgetMaker") {
        let x_axis_data;
        let breakdown_by_data = [];
        let y_series_flag = getWidgetMakerFlag(widgetGraphConfig, wm_api_flag);
        if (!y_series_flag?.flag) {
          if (
            widgetGraphConfig?.x_axis?.attribute === "CreatedDate" ||
            (widgetGraphConfig?.breakdown_by &&
              Array.isArray(widgetGraphConfig?.breakdown_by) &&
              widgetGraphConfig?.breakdown_by?.some((y_axis) =>
                graphConditionConfig?.["date-attributes"]?.includes(
                  y_axis?.attribute
                )
              ))
          ) {
            let twoMonthsDuration = getCustomizedDate(6, "Days");
            let defaultDuration = {
              from:
                moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
                " " +
                twoMonthsDuration?.time?.startTime,
              to:
                moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
                " " +
                twoMonthsDuration?.time?.endTime,
            };
            let yAxesDateAttr =
              widgetGraphConfig?.breakdown_by &&
              Array.isArray(widgetGraphConfig?.breakdown_by)
                ? widgetGraphConfig?.breakdown_by?.some((y_axis) =>
                    graphConditionConfig?.["date-attributes"]?.includes(
                      y_axis?.attribute
                    )
                  )
                  ? widgetGraphConfig?.breakdown_by?.find((y_axis) =>
                      graphConditionConfig?.["date-attributes"]?.includes(
                        y_axis?.attribute
                      )
                    )
                  : null
                : null;
            let getIntervalForXAxis = getTimeIntervalForDate(
              obj ? obj?.to : defaultDuration?.to,
              obj ? obj?.from : defaultDuration?.from,
              widgetGraphConfig && widgetGraphConfig?.chart_type,
              widgetGraphConfig?.x_axis?.attribute
            );
            let getIntervalForYAxis = getTimeIntervalForDate(
              obj ? obj?.to : defaultDuration?.to,
              obj ? obj?.from : defaultDuration?.from,
              widgetGraphConfig && widgetGraphConfig?.chart_type,
              yAxesDateAttr?.attribute
            );
            if (
              graphConditionConfig?.[`date-attributes`]?.includes(
                widgetGraphConfig?.x_axis?.attribute
              ) &&
              (!widgetGraphConfig?.x_axis?.date_part ||
                widgetGraphConfig?.x_axis?.date_part === "D")
              // Commenting for future used if need reset datepart
              // (!widgetGraphConfig?.x_axis?.date_part ||
              //   (Array.isArray(getIntervalForXAxis?.timeList) &&
              //     !getIntervalForXAxis?.timeList?.includes(
              //       widgetGraphConfig?.x_axis?.date_part
              //     )))
            ) {
              x_axis_data = { ...widgetGraphConfig?.x_axis };
              // if (
              //   Array.isArray(getIntervalForXAxis?.timeList) &&
              //   !getIntervalForXAxis?.timeList?.includes(
              //     widgetGraphConfig?.x_axis?.date_part
              //   )
              // ) {
              //   x_axis_data.date_part = getIntervalForXAxis.defaultVal;
              //   callNotification(
              //     "Date Part is Reset as per selected duration",
              //     "info"
              //   );
              // }
              x_axis_data.date_aggregation = getIntervalForXAxis.defaultVal;
            }

            if (
              widgetGraphConfig?.breakdown_by &&
              Array.isArray(widgetGraphConfig?.breakdown_by) &&
              widgetGraphConfig?.breakdown_by?.some(
                (y_axis) =>
                  graphConditionConfig?.["date-attributes"]?.includes(
                    y_axis?.attribute
                  ) &&
                  (!y_axis?.date_part || y_axis?.date_part === "D")
                // Commenting for future used if need reset datepart
                // (!y_axis?.date_part ||
                //   (Array.isArray(getIntervalForYAxis?.timeList) &&
                //     !getIntervalForYAxis?.timeList?.includes(
                //       y_axis?.date_part
                //     )))
              )
            ) {
              widgetGraphConfig?.breakdown_by?.forEach((y_axis) => {
                if (
                  graphConditionConfig?.[`date-attributes`]?.includes(
                    y_axis?.attribute
                  ) &&
                  (!y_axis?.date_part || y_axis?.date_part === "D")
                  // Commenting for future used if need reset datepart
                  // (!y_axis?.date_part ||
                  //   (Array.isArray(getIntervalForYAxis?.timeList) &&
                  //     !getIntervalForYAxis?.timeList?.includes(
                  //       y_axis?.date_part
                  //     )))
                ) {
                  // if (
                  //   Array.isArray(getIntervalForYAxis?.timeList) &&
                  //   !getIntervalForYAxis?.timeList?.includes(y_axis?.date_part)
                  // ) {
                  //   y_axis.date_part = getIntervalForYAxis?.defaultVal;
                  //   callNotification(
                  //     "Date Part is Reset as per selected duration",
                  //     "info"
                  //   );
                  // }
                  y_axis.date_aggregation = getIntervalForYAxis?.defaultVal;
                }
                breakdown_by_data?.push(y_axis);
              });
            }
          }
          dispatch(
            setWidgetMakerDuration(
              obj,
              widgetGraphConfig,
              x_axis_data,
              breakdown_by_data?.length ? breakdown_by_data : []
            )
          );
        } else {
          resetState();
          getEmptyFieldNotification();
        }
      } else if (type === "split" && split === "one") {
        let check1 = check ? { ...check } : {};
        check1.one = true;
        setcheck(check1);
        onSplitDateChange(0, obj);
      } else if (type === "split" && split === "two") {
        let check1 = check ? { ...check } : {};
        check1.two = true;
        setcheck(check1);
        onSplitDateChange(1, obj);
      } else if (type === "split" && split === "three") {
        let check1 = check ? { ...check } : {};
        check1.three = true;
        setcheck(check1);
        onSplitDateChange(2, obj);
      } else if (type === "CommandCenter") {
        dispatch(setDurationInScreen(obj));
        dispatch(setScreenRefreshEvent(false));
        dispatch(setClearAllScreenWidgetGraphData());

        // Reset Category screen filters
        if (authParams?.screen_id === "000-000-552") {
          let updatedFilters = [];
          dispatch(setCategoryScreenFilters(updatedFilters));
        }
      }
      setDatepicker(!datePicker); //to close the date picker
      settimeFlag([
        { type: "start", data: { value: false, msg: null } },
        { type: "end", data: { value: false, msg: null } },
      ]);
      onCancel();
    }
  };

  const onClearDuration = (checked_type) => {
    if (type === "dashboard_section" && editPanelInfo) {
      //need to reset label value
      let durationObject = {
        type: type,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setSectionDateValue(durationObject));
      let index = getPaneIndex(panes, activeKey);
      let global_duration = panes[index].duration;
      let paneObject = {
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        section_index: editPanelInfo?.section_index,
        duration: null,
        global_duration: global_duration,
        index: index,
      };
      dispatch(updateSectionDuration(paneObject));
      dispatch(
        setClearBrandAndDuration({
          ...clearBrandAndDuration,
          sectionLevelDuration: true,
        })
      );
    } else if (type === "dashboard_widget" && editPanelInfo) {
      //need to reset label value
      let durationObject = {
        type: type,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setWidgetDateValue(durationObject));
      let index = getPaneIndex(panes, activeKey);
      let global_duration = panes[index].duration;
      let paneObject = {
        index: index,
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        duration: null,
        section_index: editPanelInfo?.section_index,
        widget_index: editPanelInfo?.widget_index,
        global_duration: global_duration,
      };
      dispatch(updateWidgetDuration(paneObject));
      dispatch(
        setClearBrandAndDuration({
          ...clearBrandAndDuration,
          widgetLevelDuration: true,
        })
      );
    } else if (type === "template_section") {
      if (!Section[selectedSection?.section_index]?.dateFilters) {
        dispatch(setIsWidgetEdit(false));
        dispatch(setIsNetworkWidgetSettingEdit(false));
        dispatch(setNetworkWidgetSettingObject(null));
        return;
      }
      //need to reset label value
      let durationObject = {
        type: type,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setSectionDateValue(durationObject));
      let templateObj1 = {
        section: Section,
        templateDetails: templateDetails,
        section_index: editPanelInfo?.section_index,
        authParams: authParams,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        duration: templateDetails?.templateDuration, //for graph fetch global duration
        durationObj: null,
      };

      dispatch(setSectionDuration(templateObj1));
      let global = templateDetails?.templateFilters
        ? templateDetails?.templateFilters
        : [];
      let global_brands = templateDetails?.templateBrands
        ? templateDetails?.templateBrands
        : null;
      let global_duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : null;
      let templateObj = {
        section: Section,
        templateDetails: templateDetails,
        section_index: selectedSection?.section_index,
        authParams: authParams,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        global_brands: global_brands,
        filters: Section[selectedSection?.section_index]?.onlyFilters,
        duration: null,
        is_locked: selectedSection?.is_locked,
        brandFilters: Section[selectedSection?.section_index]?.brandFilters,
        dateFilters: null,
        clear: false,
      };
      dispatch(
        setTemplateSectionFilter(templateObj, false, {
          ...clearBrandAndDuration,
          sectionLevelDuration: true,
        })
      );
      let obj1 = {
        type: "template_section",
        filters: global,
        section: Section,
        brands: templateDetails?.brands
          ? templateDetails?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        authParams: authParams,
        duration: global_duration,
        graphConditionConfig: graphConditionConfig,
      };
      dispatch(setIsWidgetEdit(false));
      dispatch(setIsNetworkWidgetSettingEdit(false));
      dispatch(setNetworkWidgetSettingObject(null));
      dispatch(setTemplateFilter(obj1, templateObj));
    } else if (type === "template_widget") {
      let widget_metadata =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]
          : Section?.[0]?.data?.[editPanelInfo?.widget_index];
      if (!widget_metadata?.dateFilters) {
        dispatch(setIsWidgetEdit(false));
        dispatch(setIsNetworkWidgetSettingEdit(false));
        dispatch(setNetworkWidgetSettingObject(null));
        return;
      }
      let section_metadata =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]
          : Section?.[0];

      //need to reset label value
      let durationObject = {
        type: type,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setWidgetDateValue(durationObject));

      let templateObj1 = {
        section: Section,
        templateDetails: templateDetails,
        section_index: editPanelInfo?.section_index,
        authParams: authParams,
        widget_index: editPanelInfo?.widget_index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        duration: templateDetails?.templateDuration,
        durationObj: null,
      };
      dispatch(setWidgetDuration(templateObj1));
      let global = templateDetails?.templateFilters
        ? templateDetails?.templateFilters
        : [];
      let global_brands = templateDetails?.templateBrands
        ? templateDetails?.templateBrands
        : null;
      let global_duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : null;
      let res = null;
      let newSection = deepCopy(Section);
      let updatedSection = null;
      let currectSection = deepCopy(Section?.[editPanelInfo?.section_index]);
      let forParticularSection = {
        section_index: selectedSection?.section_index
          ? selectedSection?.section_index
          : 0,
        section_id: currectSection?.id,
        widget_id: selectedSection?.id,
        widget_index: selectedSection?.widget_index,
      };
      // if dupliates widget exists and global brand is competitor then need split again
      let secLockedOnBrand =
        currectSection?.is_locked &&
        currectSection?.brands &&
        currectSection?.brands?.length > 0 &&
        (currectSection?.brands?.[0]?.columns
          ? !currectSection?.brands?.[0]?.columns?.[0]?.competitor
          : !currectSection?.brands?.[0]?.competitor);
      let comBrandtypeExists =
        currectSection?.comp_brand_type === false ||
        currectSection?.comp_brand_type === true
          ? true
          : false;
      let currectWidget =
        currectSection?.data && currectSection?.data?.length > 0
          ? currectSection?.data?.[selectedSection?.widget_index]
          : currectSection?.widgets?.[selectedSection?.widget_index];
      let widgetLockedOnBrand =
        selectedSection?.is_locked &&
        currectWidget?.brands?.length > 0 &&
        (currectWidget?.brands?.[0]?.columns
          ? !currectWidget?.brands?.[0]?.columns?.[0]?.competitor
          : !currectWidget?.brands?.[0]?.competitor);
      let comBrand = global_brands?.columns?.[0]?.competitor
        ? global_brands?.columns?.[0]
        : global_brands?.[0]?.competitor
        ? global_brands?.[0]
        : global_brands?.competitor
        ? global_brands
        : null;
      if (
        comBrand &&
        !secLockedOnBrand &&
        !comBrandtypeExists &&
        !widgetLockedOnBrand &&
        currectWidget?.chart &&
        currectWidget?.chart?.["chart_settings"]["duplicate_for_brands"]
      ) {
        res = checkForDuplicateWidgets(newSection, forParticularSection);
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets(
            newSection,
            forParticularSection
          );
          if (filterSectionData !== null) {
            let iOfW = filterSectionData?.[forParticularSection?.section_index]
              ?.data?.length
              ? filterSectionData?.[
                  forParticularSection?.section_index
                ]?.data?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                )
              : filterSectionData?.[
                  forParticularSection?.section_index
                ]?.widgets?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                );
            if (iOfW !== -1) {
              // if (
              //   filterSectionData?.[forParticularSection?.section_index]?.data
              //     ?.length
              // ) {
              //   filterSectionData[forParticularSection?.section_index].data[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // } else {
              //   filterSectionData[forParticularSection?.section_index].widgets[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // }
            }
            let newBrandList = [];
            newBrandList.push({
              brand_id: comBrand?.name,
              brand_name: comBrand?.brand_name,
              brand_friendly_name: comBrand?.brand_friendly_name,
            });
            comBrand?.competitorList?.forEach((competitorBrand) => {
              newBrandList.push(competitorBrand);
            });
            updatedSection = splitSectionWidgets(
              filterSectionData,
              newBrandList,
              brands
            );
          }
        } else if (res?.duplicateExists) {
          let newBrandList = [];
          newBrandList.push({
            brand_id: comBrand?.name,
            brand_name: comBrand?.brand_name,
            brand_friendly_name: comBrand?.brand_friendly_name,
          });
          comBrand?.competitorList?.forEach((competitorBrand) => {
            newBrandList.push(competitorBrand);
          });
          updatedSection = splitSectionWidgets(
            newSection,
            newBrandList,
            brands
          );
        }
      } else if (
        currectWidget?.chart &&
        currectWidget?.chart?.["chart_settings"]["duplicate_for_brands"]
      ) {
        res = checkForDuplicateWidgets(newSection, forParticularSection);
        if (res?.parentExists) {
          let filterSectionData = getFilterDuplicateWidgets(
            newSection,
            forParticularSection
          );
          if (filterSectionData !== null) {
            let iOfW = filterSectionData?.[forParticularSection?.section_index]
              ?.data?.length
              ? filterSectionData?.[
                  forParticularSection?.section_index
                ]?.data?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                )
              : filterSectionData?.[
                  forParticularSection?.section_index
                ]?.widgets?.findIndex(
                  (el) => el?.widget_id === forParticularSection?.widget_id
                );
            if (iOfW !== -1) {
              // if (
              //   filterSectionData?.[forParticularSection?.section_index]?.data
              //     ?.length
              // ) {
              //   filterSectionData[forParticularSection?.section_index].data[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // } else {
              //   filterSectionData[forParticularSection?.section_index].widgets[
              //     iOfW
              //   ] = currectWidget; // need to assign updated widget metadata
              // }
            }
            updatedSection = filterSectionData;
          }
        }
      }
      let needToBeUpdateSectionAllWidgetsWithId = null;
      if (
        res &&
        (res?.duplicateExists || res?.parentExists) &&
        updatedSection
      ) {
        Section[editPanelInfo?.section_index] =
          updatedSection?.[editPanelInfo?.section_index];
        needToBeUpdateSectionAllWidgetsWithId = {
          ...forParticularSection,
        };
      }
      let templateObj = {
        section: Section,
        templateDetails: templateDetails,
        section_index: selectedSection?.section_index,
        widget_index: selectedSection?.widget_index,
        authParams: authParams,
        global_brands: global_brands,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        filters: selectedSection?.section_index
          ? Section[selectedSection?.section_index]?.data[
              selectedSection?.widget_index
            ]?.onlyFilters
          : Section[0]?.data[selectedSection?.widget_index]?.onlyFilters,
        duration: global_duration,
        is_locked: selectedSection?.is_locked,
        brandFilters: selectedSection?.section_index
          ? Section[selectedSection?.section_index]?.data[
              selectedSection?.widget_index
            ]?.brandFilters
          : Section[0]?.data[selectedSection?.widget_index]?.brandFilters,
        dateFilters: null,
        clear: false,
        profile_filters: widget_metadata?.profile_filters
          ? widget_metadata?.profile_filters
          : null,
        profile_filters_list:
          widget_metadata?.is_locked && widget_metadata?.profile_filters_list
            ? widget_metadata?.profile_filters_list
            : section_metadata?.brands && section_metadata?.profile_filters_list
            ? section_metadata?.profile_filters_list
            : profileFilterList,
        profile_filters_flag: widget_metadata?.profile_filters_flag,
      };
      dispatch(
        setTemplateWidgetFilter(
          templateObj,
          false,
          {
            ...clearBrandAndDuration,
            widgetLevelDuration: true,
          },
          needToBeUpdateSectionAllWidgetsWithId
        )
      );
      let obj1 = {
        type: "template_widget",
        filters: global,
        section: templateObj?.section ? templateObj?.section : Section,
        brands: templateDetails?.brands
          ? templateDetails?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        authParams: authParams,
        duration: global_duration,
        graphConditionConfig: graphConditionConfig,
      };
      dispatch(setIsWidgetEdit(false));
      dispatch(setIsNetworkWidgetSettingEdit(false));
      dispatch(setNetworkWidgetSettingObject(null));
      dispatch(setTemplateFilter(obj1, templateObj));
    } else if (type === "advance_settings") {
      dispatch(
        setTemplateDetails(templateDetails, {
          advance_duration: {},
        })
      );
      let index = getPaneIndex(panes, activeKey);
      let paneObject = {
        duration: null,
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        singleBrands: brands,
        index: index,
        templateGlobalDuration: null,
      };

      dispatch(setPaneDuration(paneObject, "global_dashboard"));

      //need to reset label value
      let durationObject = {
        type: type,
        value: null,
        dateValue: dateValue,
        timeValue: timeValue,
      };
      dispatch(setGlobalDateValue(durationObject)); // used for advanced setting
    }
    settimeFlag([
      { type: "start", data: { value: false, msg: null } },
      { type: "end", data: { value: false, msg: null } },
    ]);
    onCancel();
  };
  const handleCancel = () => {
    setIsModalVisible1(false);
    resetState();
  };
  const handleOnSelectChange = (el) => {
    if (el.target.checked) {
      if (type === "split" && el?.target?.id === "one") {
        onDoneButton(el?.target?.id);
        let check1 = check ? { ...check } : {};
        check1.one = true;
        setcheck(check1);
      } else if (type === "split" && el?.target?.id === "two") {
        let check1 = check ? { ...check } : {};
        check1.two = true;
        setcheck(check1);
        onDoneButton(el?.target?.id);
      } else if (type === "split" && el?.target?.id === "three") {
        let check1 = check ? { ...check } : {};
        check1.three = true;
        setcheck(check1);
        onDoneButton(el?.target?.id);
      }
    } else if (!el.target.checked) {
      if (type === "split" && el?.target?.id === "one") {
        let check1 = check ? { ...check } : {};
        check1.one = false;
        setcheck(check1);
        onSplitDateChange(0, null);
      } else if (type === "split" && el?.target?.id === "two") {
        let check1 = check ? { ...check } : {};
        check1.two = false;
        setcheck(check1);
        onSplitDateChange(1, null);
      } else if (type === "split" && el?.target?.id === "three") {
        let check1 = check ? { ...check } : {};
        check1.three = false;
        setcheck(check1);
        onSplitDateChange(2, null);
      }
    }
  };
  const handleModalYes = () => {
    dispatch(setGraphDuration(isModalVisible1?.data, graphDetail));
    setIsModalVisible1({ value: false, data: null });
  };
  const handleOpenChange = (newOpen) => {
    if (authParams?.screen_id && screen?.selected_duration_type === "Custom") {
      dispatch(setSelectedDurationTypeFlag(false));
    }
    setDatepicker(newOpen);
  };
  return (
    <>
      <div className="d-flex">
        <span
          className={`mx-2 align-items-center font-size-14 ${
            type === "split" || type === "crisis" ? "d-flex" : "d-none"
          }`}
        >
          <Checkbox
            onChange={(item) => handleOnSelectChange(item)}
            id={type === "split" ? split : type === "crisis" && crisis}
            ref={refDatecheckbox}
            checked={
              type === "split"
                ? check
                  ? check[split]
                  : checked
                : crisis === "one"
                ? crisisChecked?.check1
                : crisis === "two"
                ? crisisChecked?.check2
                : crisis === "three" && crisisChecked?.check3
            }
          />
        </span>
        <div
          className={`from-group floating-label-group d-flex font-size-14 input-duration ${
            (graphLoader ||
              aggregateLoader ||
              profileLoader ||
              authParams?.filterScreen) &&
            type !== "schedule_date_time" &&
            type !== "schedule_duration"
              ? "disable"
              : " "
          }`}
          style={{
            alignItems: "center",
            justifyContent: "center",
            width:
              type === "CommandCenter" &&
              timeValue?.[type]?.data?.startTime &&
              timeValue?.[type]?.data?.endTime &&
              (dateValue?.[type]?.data?.["relative"]?.type === "Hours" ||
                (moment(
                  moment(dateValue?.[type]?.data?.[1]).format("DD MMM  YYYY ") +
                    timeValue?.[type]?.data?.endTime
                ).diff(
                  moment(
                    moment(dateValue?.[type]?.data?.[0]).format(
                      "DD MMM  YYYY "
                    ) + timeValue?.[type]?.data?.startTime
                  ),
                  "hours",
                  true
                ) < 24 &&
                  moment(dateValue?.[type]?.data?.[1]).format("YYYY/MM/DD") ===
                    moment(dateValue?.[type]?.data?.[0]).format("YYYY/MM/DD") &&
                  moment(new Date()).format("YYYY/MM/DD") ===
                    moment(dateValue?.[type]?.data?.[0]).format("YYYY/MM/DD") &&
                  moment(dateValue?.[type]?.data?.[0]).format("YYYY/MM/DD") !==
                    null))
                ? "13rem"
                : dashboard
                ? "31.5rem"
                : split
                ? "40rem"
                : type === "dashboard_section" ||
                  type === "dashboard_widget" ||
                  type === "global_dashboard" ||
                  type === "template_section" ||
                  type === "template_widget" ||
                  type === "preview"
                ? "100%"
                : type === "template_global"
                ? "21.7rem"
                : type === "share_modal"
                ? "28.5rem"
                : "31.5rem",
            height: type === "CommandCenter" ? "2rem" : dashboard ? "4rem" : "",
          }}
          ref={refDate}
        >
          <Popover
            //content={<div onClick={hide}>Close</div>}
            placement={type === "advance_settings" ? "right" : "bottomLeft"}
            content={
              <div
                className={`durationPopup d-block`}
                // style={{
                //   top: type === "graph_page" ? "15rem" : "4rem",
                //   left: positionY.left,
                //   marginLeft: scheduleReport ? "32rem" : "",
                //   right: type === "graph_page" ? "auto" : positionY.right,
                //   maxWidth: workspaceFormData?.extend && "55rem",
                // }}
              >
                {type === "advance_settings" ||
                type === "dashboard_section" ||
                type === "dashboard_widget" ||
                type === "template_section" ||
                type === "template_widget" ? (
                  <div className="duration__clear--container">
                    <span
                      className="duration_Clear cursor-pointer"
                      style={{ opacity: 1 }}
                      onClick={() => {
                        onClearDuration(true);
                      }}
                    >
                      Clear Duration
                    </span>
                    <span
                      className="close"
                      style={{ opacity: 1 }}
                      onClick={() => onCancel(true)}
                    >
                      &times;
                    </span>
                  </div>
                ) : (
                  <span
                    className="close"
                    style={{ opacity: 1 }}
                    onClick={() => onCancel(true)}
                  >
                    &times;
                  </span>
                )}

                <Tabs
                  defaultActiveKey="1"
                  className="workSpace__tabs"
                  onChange={() => callback()}
                >
                  <TabPane tab="Absolute" className="text-gray" key="1">
                    <Absolute
                      datePicker={datePicker}
                      type={type}
                      split={split}
                      crisis={crisis}
                      timeFlag={timeFlag}
                      setKeepAsRelative={setKeepAsRelative}
                    />
                  </TabPane>

                  {!panes?.[index]?.is_widget_maker_open_obj?.open_flag &&
                  window.location.pathname?.split("/")?.[1] !== "widgetMaker" &&
                  window?.location?.pathname?.split("/")?.[1] !==
                    "edit-widget" &&
                  (shareTemplateData?.quick_filter?.attribute ===
                    "CampaignID" ||
                    (panes?.[getPaneIndex(panes, activeKey)]?.quick_filter &&
                      panes?.[getPaneIndex(panes, activeKey)]?.quick_filter ===
                        "CampaignID" &&
                      !authParams?.screen_id) ||
                    (authParams?.screen_id &&
                      screen?.quick_filter &&
                      screen?.quick_filter?.toLowerCase() ===
                        "CampaignID"?.toLowerCase())) ? (
                    ""
                  ) : (
                    <TabPane tab="Relative" className="text-gray" key="2">
                      <Relative
                        datePicker={datePicker}
                        type={type}
                        split={split}
                        setDatepicker={setDatepicker}
                        keepAsRelative={keepAsRelative}
                        setKeepAsRelative={setKeepAsRelative}
                      />
                    </TabPane>
                  )}
                </Tabs>
                <div
                  // ${
                  //   authParams?.type == 1 || darkTheme
                  //     ? "darktheme-border-color"
                  //     : ""
                  // }
                  className={`durationPopup__footer p-15 border-top  text-right d-flex align-items-center justify-content-between`}
                >
                  <span className={`text_regular font-size12`}>
                    <i className="fas fa-calendar-alt blue-text " />{" "}
                    {localDate && localDate[0]},
                    {" " + localTime ? (
                      <span style={{ marginLeft: "0.2rem" }}>
                        {localTime?.startTime}
                      </span>
                    ) : (
                      "00:00"
                    )}{" "}
                    - {localDate && localDate[1]},{" "}
                    {" " + localTime ? localTime?.endTime : "23:59"}
                  </span>
                  <div>
                    {timeFlag[0]?.data?.value || timeFlag[1]?.data?.value ? (
                      <Button
                        disabled
                        className="btn_Clear ml-15"
                        onClick={() => onCancel(true)}
                      >
                        Cancel
                      </Button>
                    ) : (
                      <Button
                        // ${
                        //   authParams?.theme_type == 1 || darkTheme
                        //     ? "darkThemebtn"
                        //     : ""
                        // }
                        className={`btn_Clear ml-15`}
                        onClick={() => onCancel(true)}
                      >
                        Cancel
                      </Button>
                    )}
                    <Button
                      key="submit"
                      type="primary"
                      className="ant-btn-primary_blue ml-15"
                      onClick={() => {
                        onDoneButton();
                      }}
                    >
                      Done
                    </Button>
                  </div>
                </div>
              </div>
            }
            title={null}
            trigger="click"
            open={datePicker}
            onOpenChange={handleOpenChange}
            className="w-100"
            // ${
            //   authParams?.theme_type == 1 ? "darkTheme" : ""
            // }
            overlayClassName={`durationPopup__overlay `}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "1vw",
                height: "4.2rem",
                // marginTop: "1.3vh",
              }}
            >
              <input
                id="Duration"
                className="portlet-input cursor-pointer w-100"
                value={
                  !dateValue?.[type]?.data
                    ? "No Duration"
                    : split === "one" && dateValue?.[type]?.data?.one
                    ? `${
                        moment(dateValue?.[type]?.data?.one?.[1]).diff(
                          moment(dateValue?.[type]?.data?.one?.[0]),
                          "days"
                        ) + 1
                      } day(s) (${dateValue?.[type]?.data?.one?.[0]} - ${
                        dateValue?.[type]?.data?.one?.[1]
                      })`
                    : split === "two" && dateValue?.[type]?.data?.two
                    ? `${
                        moment(dateValue?.[type]?.data?.two?.[1]).diff(
                          moment(dateValue?.[type]?.data?.two?.[0]),
                          "days"
                        ) + 1
                      } day(s) (${dateValue?.[type]?.data?.two?.[0]} - ${
                        dateValue?.[type]?.data?.two?.[1]
                      })`
                    : split === "three" && dateValue?.[type]?.data?.three
                    ? `${
                        moment(dateValue?.[type]?.data?.three?.[1]).diff(
                          moment(dateValue?.[type]?.data?.three?.[0]),
                          "days"
                        ) + 1
                      } day(s) (${dateValue?.[type]?.data?.three?.[0]} - ${
                        dateValue?.[type]?.data?.three?.[1]
                      })`
                    : dateValue?.[type]?.data?.["relative"]?.type === "Hours"
                    ? Math?.ceil(
                        Number(dateValue?.[type]?.data?.["relative"]?.value)
                      ) +
                      " " +
                      dateValue?.[type]?.data?.["relative"]?.type +
                      (type === "CommandCenter"
                        ? ""
                        : ` (${dateValue?.[type]?.data?.[0]} - ${dateValue?.[type]?.data?.[1]})`)
                    : timeValue?.[type]?.data?.startTime &&
                      timeValue?.[type]?.data?.endTime
                    ? moment(
                        moment(dateValue?.[type]?.data?.[1]).format(
                          "DD MMM  YYYY "
                        ) + timeValue?.[type]?.data?.endTime
                      ).diff(
                        moment(
                          moment(dateValue?.[type]?.data?.[0]).format(
                            "DD MMM  YYYY "
                          ) + timeValue?.[type]?.data?.startTime
                        ),
                        "hours",
                        true
                      ) < 24 &&
                      type === "CommandCenter" &&
                      moment(dateValue?.[type]?.data?.[1]).format(
                        "YYYY/MM/DD"
                      ) ===
                        moment(dateValue?.[type]?.data?.[0]).format(
                          "YYYY/MM/DD"
                        ) &&
                      moment(new Date()).format("YYYY/MM/DD") ===
                        moment(dateValue?.[type]?.data?.[0]).format(
                          "YYYY/MM/DD"
                        ) &&
                      moment(dateValue?.[type]?.data?.[0]).format(
                        "YYYY/MM/DD"
                      ) !== null
                      ? "Today "
                      : moment(
                          moment(dateValue?.[type]?.data?.[1]).format(
                            "DD MMM  YYYY "
                          ) + timeValue?.[type]?.data?.endTime
                        ).diff(
                          moment(
                            moment(dateValue?.[type]?.data?.[0]).format(
                              "DD MMM  YYYY "
                            ) + timeValue?.[type]?.data?.startTime
                          ),
                          "hours",
                          true
                        ) < 24 &&
                        dateValue?.[type]?.data?.["relative"]?.type !== "Days"
                      ? Math?.ceil(
                          Number(
                            moment(
                              moment(dateValue?.[type]?.data?.[1]).format(
                                "DD MMM  YYYY "
                              ) + timeValue?.[type]?.data?.endTime
                            ).diff(
                              moment(
                                moment(dateValue?.[type]?.data?.[0]).format(
                                  "DD MMM  YYYY "
                                ) + timeValue?.[type]?.data?.startTime
                              ),
                              "hours",
                              true
                            )
                          )
                        ) +
                        " " +
                        "Hours " +
                        ` (${dateValue?.[type]?.data?.[0]} - ${dateValue?.[type]?.data?.[1]})`
                      : `${Math?.ceil(
                          Number(
                            moment(
                              moment(dateValue?.[type]?.data?.[1]).format(
                                "DD MMM  YYYY "
                              ) + timeValue?.[type]?.data?.endTime
                            ).diff(
                              moment(
                                moment(dateValue?.[type]?.data?.[0]).format(
                                  "DD MMM  YYYY "
                                ) + timeValue?.[type]?.data?.startTime
                              ),
                              "days",
                              true
                            )
                          )
                        )} day(s) (${dateValue?.[type]?.data?.[0]} - ${
                          dateValue?.[type]?.data?.[1]
                        })`
                    : `${
                        moment(dateValue?.[type]?.data?.[1]).diff(
                          moment(dateValue?.[type]?.data?.[0]),
                          "days"
                        ) + 1
                      } day(s) (${dateValue?.[type]?.data?.[0]} - ${
                        dateValue?.[type]?.data?.[1]
                      })`
                }
                // value={
                //   type === "global_dashboard" && dateValue
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data[1]).diff(
                //             moment(dateValue[type]?.data[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data[0]} - ${
                //           dateValue[type]?.data[1]
                //         })`
                //     : type === "dashboard_section" && dateValue
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data[1]).diff(
                //             moment(dateValue[type]?.data[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data[0]} - ${
                //           dateValue[type]?.data[1]
                //         })`
                //     : type === "dashboard_widget" && dateValue
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data[1]).diff(
                //             moment(dateValue[type]?.data[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data[0]} - ${
                //           dateValue[type]?.data[1]
                //         })`
                //     : type === "template_global" && dateValue
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data[1]).diff(
                //             moment(dateValue[type]?.data[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data[0]} - ${
                //           dateValue[type]?.data[1]
                //         })`
                //     : type === "advance_settings" && dateValue
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data[1]).diff(
                //             moment(dateValue[type]?.data[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data[0]} - ${
                //           dateValue[type]?.data[1]
                //         })`
                //     : type === "template_section" && dateValue
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data[1]).diff(
                //             moment(dateValue[type]?.data[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data[0]} - ${
                //           dateValue[type]?.data[1]
                //         })`
                //     : type === "template_widget"
                //     ? dateValue &&
                //       dateValue[type]?.data["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data[1]).diff(
                //             moment(dateValue[type]?.data[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data[0]} - ${
                //           dateValue[type]?.data[1]
                //         })`
                //     : (type === "graph_page" ||
                //         type === "schedule_duration" ||
                //         type === "schedule_date_time") &&
                //       dateValue
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data[1]).diff(
                //             moment(dateValue[type]?.data[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data[0]} - ${
                //           dateValue[type]?.data[1]
                //         })`
                //     : type === "preview" && dateValue
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data[1]).diff(
                //             moment(dateValue[type]?.data[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data[0]} - ${
                //           dateValue[type]?.data[1]
                //         })`
                //     : type === "split" && split === "one" && dateValue[type]
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data?.one[1]).diff(
                //             moment(dateValue[type]?.data?.one[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data?.one[0]} - ${
                //           dateValue[type]?.data?.one[1]
                //         })`
                //     : type === "split" && split === "two" && dateValue
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data?.two[1]).diff(
                //             moment(dateValue[type]?.data?.two[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data?.two[0]} - ${
                //           dateValue[type]?.data?.two[1]
                //         })`
                //     : type === "split" && split === "three" && dateValue
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data?.three[1]).diff(
                //             moment(dateValue[type]?.data?.three[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data?.three[0]} - ${
                //           dateValue[type]?.data?.three[1]
                //         })`
                //     : type === "orm_dashboard" && dateValue
                //     ? dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data[1]).diff(
                //             moment(dateValue[type]?.data[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data[0]} - ${
                //           dateValue[type]?.data[1]
                //         })`
                //     : type === "share_modal"
                //     ? dateValue &&
                //       dateValue[type]?.data?.["relative"]?.type === "Hours"
                //       ? dateValue[type]?.data?.["relative"]?.value +
                //         " " +
                //         dateValue[type]?.data?.["relative"]?.type +
                //         ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //       : `${
                //           moment(dateValue[type]?.data[1]).diff(
                //             moment(dateValue[type]?.data[0]),
                //             "days"
                //           ) + 1
                //         } day(s) (${dateValue[type]?.data[0]} - ${
                //           dateValue[type]?.data[1]
                //         })`
                //     : type === "widgetMaker" &&
                //       dateValue &&
                //       dateValue[type]?.data?.["relative"]?.type === "Hours"
                //     ? dateValue[type]?.data?.["relative"]?.value +
                //       " " +
                //       dateValue[type]?.data?.["relative"]?.type +
                //       ` (${dateValue[type]?.data[0]} - ${dateValue[type]?.data[1]})`
                //     : `${
                //         moment(dateValue[type]?.data[1]).diff(
                //           moment(dateValue[type]?.data[0]),
                //           "days"
                //         ) + 1
                //       } day(s) (${dateValue[type]?.data[0]} - ${
                //         dateValue[type]?.data[1]
                //       })`
                // }
                onClick={(e) => onOpen(e)}
                type="text"
                required
                readOnly
              />
              <img
                src={
                  authParams?.theme_type === "1" // || darkTheme
                    ? durationWhiteIcon
                    : durationIcon
                }
                className="durationIcon"
                alt="duration Icon"
              />
            </div>
            {!dashboard && type !== "CommandCenter" && (
              <label
                htmlFor="Duration"
                className={`portlet-label floating-label ${
                  type === "crisis" ? "d-none" : ""
                }`}
                style={{ marginLeft: type === "split" ? "0" : "0" }}
              >
                Duration
              </label>
            )}
          </Popover>
        </div>
      </div>
      <Modal
        title=""
        closable={false}
        visible={isModalVisible1?.value}
        className={`warning_popup ${
          authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
        }`}
        footer={
          <>
            <Button onClick={() => handleCancel()} className="btn_Clear">
              No
            </Button>
            <Button
              type="primary"
              className="ant-btn-primary_blue"
              onClick={() => handleModalYes()}
            >
              Yes
            </Button>
          </>
        }
      >
        <div className="mb-0 text_heading-Slab text-transform__none">
          Are you sure you want to change the duration
        </div>
        <div className="text_regular">
          After changing the duration, split data might affect widgets
        </div>
      </Modal>
    </>
  );
};

export default React.memo(Datetime, isEqual);
